<template>
  <div>
    <div v-if="showDialogContainer">
      <div class="dialogBg">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogBg",
  computed: {
    showDialogContainer() {
      return !!this.$store.getters.showDialogContainer;
    },
  },
}
</script>

<style scoped lang="scss">
.dialogBg {
  background-color: rgba(black, 0.93) !important;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
}
</style>
